import _extends from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Modal, Icon } from "../../_global";
import { colours, fontSizes, customFonts } from "../../../constants/css";
import Slider from 'react-slick';
import Card from "../List/Card";
import { ArrowIcon } from "../../_global/Icons";
import { CardPrevArrowContainer, CardNextArrowContainer } from "../../OffersCarousel/style";
import BroadcastChannel from 'broadcast-channel';
import { CardSlickSettings } from "./merchantUtils";
var Container = styled.div.withConfig({
  displayName: "TrackingConfirmation__Container",
  componentId: "sc-jlr6j1-0"
})(["margin:2rem 0 2rem;padding:0 1.5rem;"]);
var ConfirmationContainer = styled.div.withConfig({
  displayName: "TrackingConfirmation__ConfirmationContainer",
  componentId: "sc-jlr6j1-1"
})(["margin-bottom:1rem;text-align:center;"]);
var ConfirmationInfo = styled.p.withConfig({
  displayName: "TrackingConfirmation__ConfirmationInfo",
  componentId: "sc-jlr6j1-2"
})(["font-size:", ";font-family:", ";margin:1rem 0 0.5rem;"], fontSizes.xl, customFonts.ciutadellaMed);
var ConfirmationBody = styled.p.withConfig({
  displayName: "TrackingConfirmation__ConfirmationBody",
  componentId: "sc-jlr6j1-3"
})(["margin-top:0;"]);
var ConfirmationTick = styled.div.withConfig({
  displayName: "TrackingConfirmation__ConfirmationTick",
  componentId: "sc-jlr6j1-4"
})(["display:flex;align-items:center;justify-content:center;width:50px;height:50px;border-radius:50%;background:", ";flex-shrink:0;margin:auto;"], colours.qantasLightCyan);
var OtherStores = styled.div.withConfig({
  displayName: "TrackingConfirmation__OtherStores",
  componentId: "sc-jlr6j1-5"
})(["background-color:#bababa19;padding:0.5rem 0 1rem;margin-bottom:2rem;> p{padding-left:2rem;font-family:", ";font-size:", ";}"], customFonts.ciutadellaMed, fontSizes.xl);
var StyledCardWrapper = styled.div.withConfig({
  displayName: "TrackingConfirmation__StyledCardWrapper",
  componentId: "sc-jlr6j1-6"
})(["position:relative;overflow:hidden;padding-top:0.5rem;.slick-disabled{display:none !important;}.slick-list{padding-left:2rem;overflow:initial;}img{margin:auto;}"]);
var TrackingConfirmation = /*#__PURE__*/function (_Component) {
  function TrackingConfirmation(props) {
    var _this;
    _classCallCheck(this, TrackingConfirmation);
    _this = _callSuper(this, TrackingConfirmation, [props]);
    _this.onChannelMessage = function () {
      _this.setState({
        isDismissed: false,
        trackingConfirmed: true
      });
    };
    _this.dismissModal = function () {
      _this.setState({
        isDismissed: true
      });
    };
    _this.state = {
      isDismissed: false,
      activeSlide: 0,
      trackingConfirmed: false
    };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }
  _inherits(TrackingConfirmation, _Component);
  return _createClass(TrackingConfirmation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var channel = new BroadcastChannel('qshopping');
      channel.onmessage = function (msg) {
        return _this2.onChannelMessage(msg);
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.trackingConfirmed && !prevProps.trackingConfirmed) {
        /* eslint-disable react/no-did-update-set-state */
        this.setState({
          isDismissed: false,
          trackingConfirmed: true
        });
      }
    }
  }, {
    key: "next",
    value: function next() {
      this.slider.slickNext();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.slider.slickPrev();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        isDismissed = _this$state.isDismissed,
        activeSlide = _this$state.activeSlide,
        trackingConfirmed = _this$state.trackingConfirmed;
      var merchants = this.props.merchants;
      CardSlickSettings.beforeChange = function (current, next) {
        _this3.setState({
          activeSlide: next
        });
      };
      return __jsx(Modal, {
        show: !isDismissed && trackingConfirmed,
        onClose: this.dismissModal,
        width: 630
      }, __jsx(Container, null, __jsx(ConfirmationTick, null, __jsx(Icon, {
        iconType: "tick"
      })), __jsx(ConfirmationContainer, null, __jsx(ConfirmationInfo, null, "We are tracking your purchase"), __jsx(ConfirmationBody, null, "Simply make a purchase and we will do the rest for you"))), merchants.length > 0 && __jsx(OtherStores, null, __jsx("p", null, "You may also like "), __jsx(StyledCardWrapper, null, activeSlide !== 0 && __jsx(CardPrevArrowContainer, {
        onClick: this.previous
      }, __jsx(ArrowIcon, {
        direction: "left"
      })), merchants.length > 0 && __jsx(CardNextArrowContainer, {
        onClick: this.next
      }, __jsx(ArrowIcon, {
        direction: "right"
      })), __jsx(Slider, _extends({}, CardSlickSettings, {
        ref: function ref(arg) {
          _this3.slider = arg;
        }
      }), merchants.map(function (merchant) {
        return __jsx(Card, {
          merchant: merchant,
          key: merchant.merchantId,
          onClick: _this3.dismissModal
        });
      })))));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$shop = _ref.shop,
    showCookieWarning = _ref$shop.showCookieWarning,
    clickUrl = _ref$shop.clickUrl,
    clickUrlError = _ref$shop.clickUrlError;
  return {
    trackingConfirmed: !showCookieWarning && clickUrl && !clickUrlError
  };
};
TrackingConfirmation.defaultProps = {
  merchants: [],
  trackingConfirmed: false
};
export default connect(mapStateToProps)(TrackingConfirmation);